import {APOLLO_NAMED_OPTIONS, NamedOptions} from 'apollo-angular';
import {HttpLink} from 'apollo-angular/http';
import {Provider} from '@angular/core';
import {InMemoryCache} from '@apollo/client/core';
import {environment} from '../environments/environment';
import {IpService} from './core/services/ip.service';

export const graphqlProvider: Provider = {
  provide: APOLLO_NAMED_OPTIONS,
  useFactory: apolloOptionsFactory,
  deps: [HttpLink, IpService],
};

function apolloOptionsFactory(
  httpLink: HttpLink,
  ipService: IpService,
): NamedOptions {
  const http = httpLink.create({uri: environment.graphqlUri});
  const localIPAddress = ipService.getLocalIPAddress();
  const localUri = environment.localGraphqlUri.replace('{ip}', localIPAddress);
  const localHttp = httpLink.create({uri: localUri});

  return {
    API_SERVER: {
      link: http,
      cache: new InMemoryCache({
        addTypename: false,
      }),
      defaultOptions: {
        query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
        mutate: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
      },
    },
    LOCAL_SERVER: {
      link: localHttp,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Private-Network': 'true',
        'Access-Control-Request-Private-Network': 'true',
      },
      cache: new InMemoryCache({
        addTypename: false,
      }),
      defaultOptions: {
        query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
        mutate: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
      },
    },
  };
}
